import {ProblemDestination} from '../state/global.types';
import {APIService} from '@/services/api.service';
import {FilterTag, SuggestionPois} from '@/views/amex/app-types';
import {IntersectionalFiltersDomain, buildProblem} from './build-problem';
import {Dictionary} from 'vue-router/types/router';
import {Price} from '@mobi-components/global-solution';
import {SelectOptions} from './load-alternatives';
import {TravelersIndormation} from './submit-amex-problem';

export async function downloadRecommendationContent(
  travelersInformation: TravelersIndormation,
  id: string,
  userId: string,
  origin: ProblemDestination,
  destination: ProblemDestination,
  tags: FilterTag[],
  context = 'Copenhagen_Denmark',
  budget: Price[] = [],
  sort = SelectOptions.best_match,
  intersectionalFilters: IntersectionalFiltersDomain,
): Promise<Dictionary<SuggestionPois[]>> {

  const problem = buildProblem(
    id,
    userId,
    origin,
    destination,
    tags,
    budget,
    travelersInformation,
    intersectionalFilters,
  );

  try {
    const {results} = await APIService.post<{
      results: Dictionary<SuggestionPois[]>;
    }>(`problem/poi-recommendations`, problem, {
      params: {
        context,
        merge_categories: false,
        sort,
      },
    });
    // debugger;
    return results;
  } catch (e) {
    return {};
  }
}
